import logo from './zetapelli-logo.png';

const Images = {
    logo,
}

export default Images;
